import React, { useEffect, useState, } from 'react';
import { useParams, useNavigate,useLocation  } from 'react-router-dom';
import axios from 'axios';
import './EmailVerification.css';

const EmailVerification = () => {
  const token = new URLSearchParams(useLocation().search).get('token');
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState('Verifying your email...');
  const [showResendButton, setShowResendButton] = useState(false); // State to control the visibility of the Resend button

  // Use environment variable for API URL
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${API_URL}/verify-email/${token}`);
        const data = response.data;

        if (data.success) {
          setVerificationStatus('Email verified successfully!');
          // Redirect to login after a delay
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setVerificationStatus(data.message || 'Invalid or expired token.');
          setShowResendButton(true); // Show Resend button if the token is invalid or expired
        }
      } catch (error) {
        // Handle specific cases based on the status code
        if (error.response && error.response.status === 400) {
          setVerificationStatus('Invalid or expired token.');
          setShowResendButton(true);
        } else {
          setVerificationStatus('An error occurred. Please try again later.');
        }
      }
    };

    verifyEmail();
  }, [token, navigate, API_URL]);

  const handleResendVerification = async () => {
    try {
      const response = await axios.post(`${API_URL}/resend-verification`, { token });
  
      if (response.data.success) {
        setVerificationStatus('A new verification email has been sent. Please check your inbox.');
        setShowResendButton(false); // Hide Resend button after successful resend
      } else {
        setVerificationStatus(response.data.message);
      }
    } catch (error) {
      setVerificationStatus('An error occurred while resending the verification email. Please try again later.');
    }
  };
  

  return (
    <div className="email-verification-container">
      <h2 className="email-verification-title">Email Verification</h2>
      <p className="email-verification-message">{verificationStatus}</p>
      {showResendButton && (
        <button onClick={handleResendVerification} className="email-verification-resend-btn">
          Resend Verification Email
        </button>
      )}
      {verificationStatus !== 'Verifying your email...' && (
        <button onClick={() => navigate('/login')} className="email-verification-login-anchor">
          Back to Login
        </button>
      )}
    </div>
  );
};

export default EmailVerification;
